import { isInPlaceEditingActive, provideComponent } from "scrivito"
import { MarkdownInput } from "shared/ui/input/markdown/MarkdownInput"

import { MarkdownWidget } from "./MarkdownWidgetClass"

provideComponent(MarkdownWidget, ({ widget }) => {
  return (
    <div className="markdown-widget">
      <MarkdownInput.Root
        label="Markdown Widget"
        readonly={!isInPlaceEditingActive()}
      >
        <MarkdownInput.Input
          value={widget.get("text")}
          onChange={value => widget.update({ text: value })}
        />
        <MarkdownInput.Readonly value={widget.get("text")} />
      </MarkdownInput.Root>
    </div>
  )
})
